import { render, staticRenderFns } from "./SelectScope.vue?vue&type=template&id=2b9f80a7&scoped=true&"
import script from "./SelectScope.vue?vue&type=script&lang=js&"
export * from "./SelectScope.vue?vue&type=script&lang=js&"
import style0 from "./SelectScope.vue?vue&type=style&index=0&id=2b9f80a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f80a7",
  null
  
)

export default component.exports